// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactsList_container__uPwNn","tabs":"ContactsList_tabs__2ylig","list":"ContactsList_list__1XBZn"};